// constants
export const SW = 'service-worker.js';

// exported functions
export async function checkServiceWorkerActive() {
    const registration = await getServiceWorkerRegistration()
    if (registration && registration !== undefined) {
        console.log('Service Worker is active');
    }
};

export async function getServiceWorkerRegistration() {
    try {
        return navigator.serviceWorker.getRegistration();
    } catch (error) {
        console.error('@service-worker-helpers.AQk9H', error);
    }
}

export async function getServiceWorkerRegistrations() {
    try {
        return navigator.serviceWorker.getRegistrations();
    } catch (error) {
        console.error('@service-worker-helpers.KH5m4', error);
    }
}

export async function requestNotificationPermission() {
    if ('Notification' in window) {
        try {
            // request notification permission
            const result = await Notification.requestPermission();
            if (result === 'denied') {
                console.log('User denied notifications');
            } else {
                console.log('User accepted notifications');
            }
        } catch (error) {
            console.error('@service-worker-helpers.6F0V1', error);
        }
    }
}

export async function subscribeUserToPush() {
    try {
        const registration = await navigator.serviceWorker.register(SW);
        const vapidPublicKey = 'BNGRCBNdT5V9leERrYAnF97BKefuXshHHtLYMm_olne3OODQ-g_IikLJOPGC-TkHb0f0HMZ9wMsSYjVhhppSKyg';
        const subscribeOptions = {
            applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
            userVisibleOnly: true,
        };
        // get subscription or create a new one
        let subscription = await registration.pushManager.getSubscription();
        if (!subscription) {
            subscription = await registration.pushManager.subscribe(subscribeOptions);
        }
        // log successful subscription
        console.log('subscription', subscription.toJSON());
    } catch (error) {
        console.error('@service-worker-helpers.o30nk', error);
    }
}

// local functions
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const rawDataLength = rawData.length;
    const outputArray = new Uint8Array(rawDataLength);

    for (let i = 0; i < rawDataLength; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
